import { AttachFile } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useEffect, useState } from "react"

function ImageUpload({ inputFile = undefined, multiple = true, inputProps={ name:'Upload', label: ''}, renderPreview = (p, i, close) => <img src={p.url} alt='preview' /> }) {
    const [selectedFile, setSelectedFile] = useState();
    const [previews, setPreviews] = useState([]);

    useEffect(() => {
        if (!selectedFile) {
            setPreviews([]);
            return
        }
        const objectUrl = URL.createObjectURL(selectedFile)
        let img = { url: objectUrl, file: selectedFile };
        setPreviews(multiple ? previews.concat(img) : [img]);
    }, [selectedFile])

    const removeFile = i => {
        previews.splice(i, 1);
        setPreviews([...previews]);
    }
    const onSelectFile = e => {
        if (!e.target.files || e.target.files.length === 0) {
            setSelectedFile(undefined)
            return
        }
        const allowedFileTypes = ['image/png', 'image/jpg', 'image/jpeg'];
        if (!allowedFileTypes.includes(e.target.files[0].type)) return alert('File type not allowed');
        if (previews.length >= 4) return alert('Only 4 files allowed');

        setSelectedFile(e.target.files[0])
    }

    return (
        <div>
            <div className='img-input-wrp'><input type="file" id="selectedFile" onChange={onSelectFile} />
                <Button endIcon={<AttachFile />} onClick={() => document.getElementById('selectedFile').click()}>{inputProps?.name}</Button>
                <div>{inputProps?.label}</div>
            </div>
            <div className="previews">
                {selectedFile && previews.map((p, i) => renderPreview(p, i, () => { removeFile(i) }))}
                {!selectedFile && inputFile && <img src={inputFile} alt='default' />}
            </div>
        </div>
    )
}

export default ImageUpload;